export default __webpack_public_path__ + "static/media/vacan.3f12b387.svg";